import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FascicleHistoryService, SnapshotSummary } from '../../../services/fascicle-history.service';
import { PageService } from '../../../services/page.service';

@Component({
  selector: 'app-fascicle-history-panel',
  templateUrl: './fascicle-history-panel.component.html',
  styleUrls: ['./fascicle-history-panel.component.scss'],
})
export class FascicleHistoryPanelComponent implements OnInit, OnDestroy {
  @Input() idCatalog: string;
  @Input() idFascicle: string;

  historyList: SnapshotSummary[] = [];
  restoring = false;
  confirmingId: string | null = null;

  private subs = new Subscription();

  readonly opIcons: Record<string, string> = {
    cell_update: 'pi pi-pencil',
    page_save: 'pi pi-save',
    format_change: 'pi pi-th-large',
    restore: 'pi pi-history',
  };

  readonly opLabelKeys: Record<string, string> = {
    cell_update: 'FASCICLE.HISTORY_OP_CELL_UPDATE',
    page_save: 'FASCICLE.HISTORY_OP_PAGE_SAVE',
    format_change: 'FASCICLE.HISTORY_OP_FORMAT_CHANGE',
    restore: 'FASCICLE.HISTORY_OP_RESTORE',
  };

  constructor(
    private historyService: FascicleHistoryService,
    private pageService: PageService,
    private msgService: MessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.historyService.historyList$.subscribe((list) => (this.historyList = list))
    );
    this.subs.add(
      this.historyService.restoring$.subscribe((r) => (this.restoring = r))
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  confirmRestore(snapshotId: string): void {
    this.confirmingId = snapshotId;
  }

  cancelConfirm(): void {
    this.confirmingId = null;
  }

  restore(snapshotId: string): void {
    this.confirmingId = null;
    this.historyService.restore(this.idCatalog, this.idFascicle, snapshotId).subscribe({
      next: () => {
        // Recargar desde el backend para que los CcGridCell se reinicialicen con el estado restaurado
        this.pageService.reloadPages(this.idCatalog, this.idFascicle);
        this.msgService.add({
          key: 'root-msg',
          severity: 'success',
          detail: this.translate.instant('FASCICLE.HISTORY_RESTORED'),
        });
      },
      error: () => {
        this.msgService.add({
          key: 'root-msg',
          severity: 'error',
          detail: 'Error al restaurar el estado',
        });
      },
    });
  }
}
